if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.value =  this.form.querySelector('[name=id]').value;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      const quantityInput = document.querySelector('.quantity__input');
    
      let dis = false;
      if (quantityInput ) {
        let availableQuantity = parseInt(document.querySelector('[data-available-quantity].active').textContent, 10);
        const quantity = parseInt(quantityInput.value, 10);
if (quantity > availableQuantity) {
  let size = document.querySelector('.js.product-form__input:last-of-type input:checked').value;
  
  // Update remaining quantity content
  document.querySelector('.remaining_quanity_content').textContent = `Size-${size} has only ${availableQuantity} item.`;
  
  // Add new class to '.sss'
  const sssElement = document.querySelector('.checkere');
  if (sssElement) {
    sssElement.classList.add('quantity-exceeded'); // Add new class
  }
  
  dis = true;  
} else {
  // Remove the class if condition is not met
  const sssElement = document.querySelector('.checkere');
  if (sssElement) {
    sssElement.classList.remove('quantity-exceeded'); // Remove the class
  }
}

      }
      this.cartNotification.setActiveElement(document.activeElement);
      if(dis == true) return;

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          console.log(response)
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
         
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
         
        });
    }

    handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

    // handleErrorMessage(errorMessage = false) {
    //   this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    //   if (!this.errorMessageWrapper) return;
    //   this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
    //    document.querySelector(".product__description").classList.add('check');
    //   this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    //   if (errorMessage) {
    //     let sp = errorMessage.replace('All', 'You can add only');
    //     this.errorMessage.textContent = sp;
    //   }
      //   console.log(this.value);
      // let options = Array.from(document.querySelectorAll('.custom_variants select option'));
      // let op = options.find((option)=>{
      //   return option.value == this.value;
      // })
      // const quantity = op.dataset.quantity;
      //  const name = op.textContent;
      //   console.log(quantity, name);
      // document.querySelector('.cart-notification__heading').innerHTML = 'No Item Added to Cart';
      // document.querySelector('.cart-notification-product').style.display = 'none';
    // }
  });
}










